/**
 * BMAT Layout Module
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CheckboxComponent } from './bm-checkbox.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent],
})
export class CheckboxComponentModule {}
